#import "../fragments/ContactListFields.graphql"

query ContactList($id: ID!) {
  contactList(id: $id) {
    ...ContactListFields
  }
}
